import { DEFAULT_PAGE_SIZE_PLANNER_ASSIGNMENTS } from '@/lib/constants/pagination';
import { PaginatedResponse } from '@/modules/common';
import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import { GetAssignmentsForPlannerByProjectRequest, PlannerProjectResponse } from '../types/dto';

export const getAssignmentsByProject = async ({
  filters,
  pagination,
  utilizationBasedOn,
  utilizationFilters,
  ignorePlaceholdersForGroup,
}: GetAssignmentsForPlannerByProjectRequest) => {
  const endpoint = '/api/assignments/planner/by-project/search';

  const apiData = await withApiErrorHandler(endpoint, ApiErrorCode.ASSIGNMENT_LOAD_FAILED, () =>
    axiosInstance.post<{
      data: PaginatedResponse<PlannerProjectResponse>;
      error?: { status: number; message: string; code: string };
    }>(endpoint, {
      filters,
      utilizationBasedOn,
      utilizationFilters,
      ignorePlaceholdersForGroup,
      pagination: pagination ?? {
        pageSize: DEFAULT_PAGE_SIZE_PLANNER_ASSIGNMENTS,
        cursor: null,
      },
    })
  );

  return new PaginatedResponse({
    items: apiData.items ?? [],
    pagination: apiData.pagination,
  });
};
